







































































































import {
    Component,
    Vue,
    Prop
} from "vue-property-decorator";
import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    pageDataType
} from "../types";
import {
    HOST
} from "../global";
import {
    pageData
} from "@/store/pageData";
import {
    TimelineMax,
    Expo,
    TweenLite,
    TweenMax,
    Power2,
    Power3,
    Power1
} from "gsap";

@Component({
    name: "Career",
})
export default class Career extends Vue {
    @Prop() public pageData!: pageDataType;
    @Getter("pageType") public pageType!: string | null;
    public HOST: string = HOST;
    get sums(): string[] {
        if (this.pageData != null) {
            return this.pageData.job_category_list.map((job: any, idx: number) => {
                return job.number_of_vacancy

            })
        } else {
            return []
        }

    }
    public heroimganim() {
        var heroimganim = new TimelineMax({});
        heroimganim
            .from(".banner-wrap", 1.3, {
                y: "100%",
                ease: Expo.easeInOut,
                clearProps: "all",
            })
            .from(".banner-wrap img", 0.7, {
                y: 0,
                scale: 1.2,
                ease: Power2.easeInOut,
                clearProps: "all",
            })
            .staggerFrom(
                ".banner-text",
                0.8, {
                    autoAlpha: 0,
                    height: 0,
                    ease: Expo.easeInOut,
                    clearProps: "all",
                },
                0.01,
                "-=.3"
            )
            .staggerFrom(
                ".banner-text h1",
                0.8, {
                    autoAlpha: 0,
                    y: 80,
                    ease: Expo.easeOut,
                    clearProps: "all",
                },
                0.1,
                "-=.5"
            )
            .staggerFrom(
                ".banner-text p",
                0.8, {
                    autoAlpha: 0,
                    y: 80,
                    ease: Expo.easeOut,
                    clearProps: "all",
                },
                0.1,
                "-=.6"
            );
    }
    public mounted() {
        this.heroimganim();

    }
}
